import store from '../store'

//Role types
export const ADMINISTRATIVE = 2
export const SPECIALIST = 3
export const TECHNOLOGIST = 4

//Specialties
export const OPHTHALMOLOGY = 'Oftalmología'
export const PSYCHOLOGY = 'Psicología'
export const GENERAL_MEDICINE = 'Medicina General'
export const MEDICAL_TECHNOLOGY = 'Tecnología Médica'
export const OTHER = 'Otro'
export const KINESIOLOGY = 'Kinesiología'
export const OTORHINO = 'Otorrino'

export const userRoleIs = (roleId) => {

    const currentProvider = store.state.currentProvider
    if (!currentProvider) return false

    const role = currentProvider.role
    if (!role) return false

    if (!role || !role.id) return false

    return role.id === roleId

}

export const userProvides = (specialty) => {

    const currentProvider = store.state.currentProvider
    if (!currentProvider) return false

    const role = currentProvider.role
    if (!role) return false

    if (!role || !role.id) return false

    var specialties = role && role.services_labels || []
    if (!specialties || specialties.length === 0) return false

    return specialties.includes(specialty)

}

export const appointmentConfigComponent = (specialty) => {

    if (specialty === PSYCHOLOGY) {
        return 'PsychologistAppointmentConfig'
    }
    // if (specialty === KINESIOLOGY) {
    //     return 'KinesiologistAppointmentConfig'
    // }

    return 'StandardAppointmentConfig'

}

export const needsExamConfig = () => {

    if (userProvides(OPHTHALMOLOGY)) {
        return true
    }

    //some other specialties

    return false

}

export const attentionComponent = (speciality) => {

    const settings = store.getters.specialistSettings
    if (!settings) return null
    if (settings.attention_template === 'simple') return null

    switch (speciality) {
        case OPHTHALMOLOGY:
            return 'OphthalmologicalForm'
        // case PSYCHOLOGY:
        //     return 'PsychologicalAttention'
        // case MEDICAL_TECHNOLOGY:
        //     return 'MedicalTechnologyAttention'
        // case GENERAL_MEDICINE:
        //     return 'GeneralMedicineAttention'
        default:
            return null
    }
}

export const endAttentionComponent = () => {

    if (userProvides(PSYCHOLOGY)) {
        return 'PsychologistEndAttention'
    }

    if (userProvides(MEDICAL_TECHNOLOGY)) {
        return 'TechnologistEndAttention'
    }

    return 'DefaultEndAttention'

}

export const requiresGlobalSpinner = () => {

    if (userProvides(PSYCHOLOGY)) {
        return true
    }

    return false

}

export const getRole = () => {

    const currentProvider = store.state.currentProvider
    if (!currentProvider) return null

    return currentProvider.role || null

}
